<template>
	<div id="lectures">
		<div class="row g-3">
			<div class="col-12 col-xl-9">
				<div class="card-header p-0 ff-ch">
					<ul
						class="nav nav-tabs border-0 chart-tab flex-nowrap"
						id="audience-chart-tab"
						role="tablist"
					>
						<li
							v-for="(item, index) in videoData"
							:key="'menu-' + index"
							class="nav-item bg-light me-2"
						>
							<div
								class="nav-link mb-0 text-500 fs-0"
								:class="[index == current ? 'active' : '']"
								id="users-tab"
								@click="changeLecture(index)"
								data-bs-toggle="tab"
								role="tab"
								aria-controls="users"
								aria-selected="true"
							>
								<div class="audience-tab-item p-2">
									<p class="text-center">{{ item }}</p>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	data() {
		return {
			videoData: [
				"At home rehabilitation during pandemic",
				"COVID-19 and Neuromuscular Diseases",
			],
		};
	},

	computed: {
		current() {
			return this.$route.params.index - 0 - 1;
		},
	},

	methods: {
		changeLecture(val) {
			if (this.current !== val) {
				this.$router.push(`/lecture/${val + 1}`);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.nav-link {
	cursor: pointer;
	user-select: none;
	&.active {
		color: rgb(65, 105, 178) !important;
	}
}

@media screen and (max-width: 768px) {
	#lectures {
		.row.g-3 {
			.card-header {
				ul {
					.nav-item.bg-light.me-2 {
						width: 50%;
					}
					.nav-item.bg-light.me-2:last-child {
						margin-right: 0 !important;
					}
				}
			}
		}
	}
}
</style>
